// ─── Notifications Route ("View all") ───
// /app/notifications — GHE #96.3 / #106 item 5. The bell's "View all
// notifications" footer (NotificationCenter.tsx) links here; see
// features/notifications/NotificationsPage.tsx for the page itself.

import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '../../features/notifications/NotificationsPage';

export const Route = createFileRoute('/app/notifications')({
  component: NotificationsPage,
});
